import type { ReactNode } from 'react';

/**
 * Shared definition-list primitives for detail surfaces (overview cards, detail
 * dialogs). `DescList` is the <dl> grid wrapper; `DescItem` is a label/value pair.
 * Centralises the label/value typography so every detail panel reads the same
 * across compute and kubernetes consoles.
 */
export function DescList({ children, minColumn = 200, style }: { children: ReactNode; minColumn?: number; style?: React.CSSProperties }) {
  return (
    <dl
      style={{
        margin: 0,
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${minColumn}px, 1fr))`,
        gap: 'var(--vn-space-4)',
        ...style,
      }}
    >
      {children}
    </dl>
  );
}

export function DescItem({ label, children }: { label: ReactNode; children: ReactNode }) {
  return (
    <div>
      <dt style={{ fontSize: 'var(--vn-font-size-sm)', color: 'var(--vn-fg-muted)', fontWeight: 600, marginBottom: 'var(--vn-space-1)' }}>
        {label}
      </dt>
      <dd style={{ margin: 0, fontSize: 'var(--vn-font-size-md)' }}>{children}</dd>
    </div>
  );
}

/** Inline monospace styling shared by code/IP/ID values inside DescItems. */
export const monoValue: React.CSSProperties = { fontSize: 'var(--vn-font-size-sm)' };
